import React from 'react'
import HeaderComponent from '../../components/HeaderComponent/HeaderComponent'
import styles from "./EmergencyContacts.module.css";
import { Table } from 'antd';
import {ReactComponent as PhoneVector} from "../../assets/images/phoneVector.svg"

const EmergencyContacts = () => {

      const columns = [
   {
      title: "No",
      dataIndex: "No",
      key: "No",
    },
    {
      title: "Name",
      dataIndex: "Name",
      key: "Name",
    },
    {
      title: "Numbers",
      key: "Numbers",
      dataIndex: "Numbers",
    },
    {
      title: "Actions",
      key: "Actions",
      dataIndex: "Actions",
        key: "Actions",
            render: (text, record) => (
                <div style={{cursor:"pointer" , }}>
              <PhoneVector/>
                </div>
            ),
    },

  ];

  const data = [
    {
     No: "1",
      Name: "National Emergency",
      Numbers: "911",
      Actions:"04",
    }, 
      {
     No: "2",
      Name: "Health & Safety",
      Numbers: "1-800-222-1222",
      Actions:"02",
    }, 
     {
     No: "3",
      Name: "Transportation Security",
      Numbers: "1-866-289-9673",
      Actions:"02",
        
    }, 
        {
     No: "4",
      Name: "Health & Safety",
      Numbers: "1-800-222-1222",
      Actions:"02",
    }, 
     {
     No: "5",
      Name: "Transportation Security",
      Numbers: "1-866-289-9673",
      Actions:"02",
        
    }, 
        {
     No: "6",
      Name: "Health & Safety",
      Numbers: "1-800-222-1222",
      Actions:"02",
    }, 
     {
     No: "7",
      Name: "Transportation Security",
      Numbers: "1-866-289-9673",
      Actions:"02",
        
    }, 
        {
     No: "8",
      Name: "Health & Safety",
      Numbers: "1-800-222-1222",
      Actions:"02",
    }, 
     {
     No: "9",
      Name: "Transportation Security",
      Numbers: "1-866-289-9673",
      Actions:"02",
        
    }, 
        {
     No: "10",
      Name: "Health & Safety",
      Numbers: "1-800-222-1222",
      Actions:"02",
    }, 
     {
     No: "11",
      Name: "Transportation Security",
      Numbers: "1-866-289-9673",
      Actions:"02",
        
    }, 
      
  ];

  return (
    <div>

          <HeaderComponent
                heading={"Emergency Contact Details"}
                submitButtonText={false}
                showSubmitButton={false}
                showSearch={true}
                rightControlsStyle={styles.rightControlsStyle}
                headingStyle={styles.headingStyle}
              />


           {/* Table Section */}
            <div className={styles.subCont}>
              <div className={styles.TableDiv}>
                <Table
                  scroll={{ x: true }}
                  columns={columns}
                  dataSource={data}
                  pagination={false}
                  rowKey="Actions"
                />
              </div>
            </div>
      
    </div>
  )
}

export default EmergencyContacts
